import { h, render } from 'preact';
import CartContext from './cart-context';
import Cart from './cart';
import WishlistContext from '../utils/gift-reggie/wishlist-context';

export default (element, data) => {
  const renderCart = () => {
    render(
      <CartContext data={data}>
        <WishlistContext>
          <Cart />
        </WishlistContext>
      </CartContext>,
      element,
    );
  };

  const init = () => {
    renderCart();
  };

  init();
};
